import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PaceCoreModule } from '@evorait/pace-core';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [HeaderComponent],
    imports: [CommonModule, RouterModule, PaceCoreModule.forChild(), TranslateModule.forChild(), FontAwesomeModule],
    exports: [HeaderComponent],
})
export class HeaderModule {}
